import { Button, IconButton, Stack } from "@mui/material"
import React from "react"
import { Message } from "../../km"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt"
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt"
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import { useSnackbar } from "src/providers/SnackbarProvider"
import { useResponsive } from "src/utils/useResponsive"

interface MessageActionsProps {
  index: number
  myMsg: Message
  handleThumb: (up: boolean | undefined, message: Message, index: number) => void
  onSourcesClick: () => void
  messageId: string
}

export const MessageActions = ({ index, myMsg, handleThumb, onSourcesClick, messageId }: MessageActionsProps) => {
  const { snackbarShowMessage } = useSnackbar()
  const { isMobile } = useResponsive()
  const handleCopy = () => {
    const content = document.getElementById(messageId)
    const html = content?.innerHTML

    // Create a full HTML wrapper (optional, Word sometimes prefers it)
    const fullHtml = `
  <html>
    <head>
      <meta charset="UTF-8">
    </head>
    <body>${html}</body>
  </html>
`

    navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([fullHtml], { type: "text/html" }),
        "text/plain": new Blob([content?.innerText || ""], { type: "text/plain" })
      })
    ])
    snackbarShowMessage("Copied to clipboard", "info")
  }

  return (
    <Stack direction={"row"} justifyContent={"space-between"}>
      <Button
        data-testid={`km-sources-button-${index}`}
        onClick={onSourcesClick}
        size="small"
        startIcon={
          <InfoOutlinedIcon
            fontSize={"large"}
            sx={{
              backgroundColor: "#A4E9FF",
              borderRadius: "50%",
              p: 0.3
            }}
          />
        }
        sx={{
          border: "1px solid #CCCCCC",
          borderRadius: "50px",
          fontWeight: 600,
          ml: { xs: 0, md: 8 }
        }}
      >
        Sources
      </Button>
      <Stack direction={"row"} justifyContent={"flex-end"}>
        <IconButton
          data-testid={`km-thumb-up-button-${index}`}
          onClick={() => handleThumb(true, myMsg, index)}
          sx={{
            "&:hover": { background: "transparent" }
          }}
        >
          <ThumbUpOffAltIcon />
        </IconButton>
        <IconButton
          data-testid={`km-thumb-down-button-${index}`}
          onClick={() => handleThumb(false, myMsg, index)}
          sx={{
            "&:hover": { background: "transparent" }
          }}
        >
          <ThumbDownOffAltIcon />
        </IconButton>
        {!isMobile && (
          <IconButton
            data-testid={`km-comment-button-${index}`}
            onClick={() => handleThumb(undefined, myMsg, index)}
            sx={{
              "&:hover": { background: "transparent" }
            }}
          >
            <ChatBubbleOutlineIcon />
          </IconButton>
        )}
        <IconButton
          data-testid={`km-copy-button-${index}`}
          onClick={handleCopy}
          sx={{
            "&:hover": { background: "transparent" }
          }}
        >
          <ContentCopyIcon />
        </IconButton>
      </Stack>
    </Stack>
  )
}
